import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_LIVE_CONFIG, GET_LIVE_CONFIG_SUCCESS, GET_LIVE_CONFIG_ERROR } from '../../actions';
import apiCall from '../../../apiCall';

function* getLiveConfig({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/configuration/fetch-live`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_LIVE_CONFIG_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_LIVE_CONFIG_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_LIVE_CONFIG_ERROR, payload: error });
  }
}

export function* watchgetLiveConfig() {
  yield takeEvery(GET_LIVE_CONFIG, getLiveConfig);
}

function* getLiveConfigSaga() {
  yield all([fork(watchgetLiveConfig)]);
}

export default getLiveConfigSaga;
